import React, { useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { useAuth } from "../../../hooks/useAuth";
import CircularProgress from "@mui/material/CircularProgress";
import { Tooltip } from "@mui/material";
import GeneralEmojiPicker from "../../general/GeneralEmojiPicker";

export default function ChatInput(props) {
  const { socket, userInfo } = useAuth();
  const inputRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [savedRange, setSavedRange] = useState(null);

  const {
    isSubmittingMsg,
    setIsSubmittingMsg,
    chat,
    message,
    setMessage,
    isUpdate,
    setIsUpdate,
    selectedChat,
    setSelectedChat,
    handleCancel,
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() !== "") {
      setIsSubmittingMsg(true);
      let socketEvent = "send_message";
      const socketData = {
        receiver_id: chat.id,
        conversation_id: chat.conversation_id,
        sender_id: userInfo.id,
        message: message.trim(),
      };
      if (isUpdate && selectedChat) {
        socketData.message_id = selectedChat.message_id;
        socketEvent = "update_message";
      }

      console.log(socketData, `<= ${socketEvent}`);
      socket.emit(socketEvent, socketData);
      setMessage("");
      setIsUpdate(false);
      setSelectedChat(null);
    }
  };

  const restoreSelection = () => {
    if (savedRange) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(savedRange);
    }
  };

  const onEmojiClick = (emojiObject) => {
    restoreSelection();
    const emoji = emojiObject.emoji;
    const input = inputRef.current;

    if (input) {
      const start = input.selectionStart ?? message.length;
      const end = input.selectionEnd ?? message.length;

      const newMessage =
        message.substring(0, start) + emoji + message.substring(end);
      setMessage(newMessage);
      requestAnimationFrame(() => {
        input.focus();
        input.selectionStart = input.selectionEnd = start + emoji.length;
      });
    }
  };

  const handleBlur = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setSavedRange(range);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center p-3 border-top chat-input">
        <Icon
          icon="mdi:emoticon-outline"
          width="28"
          className="me-2 cursor-pointer"
          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
        />
        <form className="input-chat-box rounded" onSubmit={handleSubmit}>
          <input
            type="text"
            className="form-control me-2"
            placeholder="Type a message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            autoFocus
            ref={inputRef}
            onBlur={handleBlur}
          />
          {isUpdate && (
            <Tooltip title="Cancel">
              <button
                type="button"
                className="message-submit-button"
                disabled={isSubmittingMsg}
                onClick={handleCancel}
              >
                <Icon
                  icon="radix-icons:cross-2"
                  width="28"
                  className="cursor-pointer text-primary"
                />
              </button>
            </Tooltip>
          )}
          <Tooltip title={isSubmittingMsg ? "" : isUpdate ? "Update" : "Send"}>
            <button
              className="message-submit-button"
              disabled={isSubmittingMsg}
            >
              {isSubmittingMsg ? (
                <CircularProgress size={22} />
              ) : (
                <Icon
                  icon="mdi:paper-plane"
                  width="28"
                  className="cursor-pointer text-primary"
                />
              )}
            </button>
          </Tooltip>
        </form>
      </div>
      {showEmojiPicker && (
        <GeneralEmojiPicker {...{ onEmojiClick, setShowEmojiPicker }} />
      )}
    </>
  );
}
